import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCartWishlistSearch } from 'b2b-apps/shop/cart/redux/wishlistSearch/actionCreators';
import { getCartWishlistSearch } from 'b2b-apps/shop/cart/redux/wishlistSearch/selectors';
import { CartWishlistSearchType } from 'b2b-apps/shop/cart/redux/wishlistSearch/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';

export type UseCartWishlistEffectReturnType = RemoteRecord<CartWishlistSearchType>;

export const useCartWishlistSearchEffect = (query = ''): UseCartWishlistEffectReturnType => {
  const dispatch = useDispatch();
  const cartWishlistsSearchData = useSelector(getCartWishlistSearch);

  useEffect(() => {
    dispatch(fetchCartWishlistSearch(query));
  }, [dispatch, query]);

  return cartWishlistsSearchData;
};
